const handleCollection = (): Record<string, unknown> => ({
  keyArgs: (args: any) => {
    if (!args || typeof args !== 'object') {
      return false
    }
    try {
      // Filter out pagination arguments to use other args as cache keys
      const keys = Object.keys(args).filter(k => k !== 'start' && k !== 'limit')
      // Return false if no distinguishing keys remain to avoid cache key issues
      return keys.length > 0 ? keys : false
    } catch (error) {
      // Fallback to false if there's any error processing args
      console.warn('Error processing keyArgs:', error)
      return false
    }
  },
  merge (existing: any, incoming: any) {
    if (!existing || incoming.meta.range.from === 1) {
      return incoming
    }

    return {
      ...incoming,
      collection: [
        ...existing.collection,
        ...incoming.collection
      ],
      meta: {
        ...incoming.meta,
        from: existing.meta.from
      }
    }
  }
})

export default handleCollection
